"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.base = void 0;
const env_1 = __importDefault(require("./env"));
exports.base = {
    cloudinary: {
        cloudName: 'cflin',
        apiKey: '531625395947836',
        apiSecret: env_1.default.CLOUDINARY_API_SECRET,
        signatureApi: undefined,
        uploadApi: 'https://api.cloudinary.com/v1_1/cflin/image/upload',
    },
};
//# sourceMappingURL=base.js.map